/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const CatalogActivationState = {
  Active: "active",
  Available: "available",
  AvailableNameBlocked: "available_name_blocked",
} as const;
export type CatalogActivationState = ClosedEnum<typeof CatalogActivationState>;

/** @internal */
export const CatalogActivationState$inboundSchema: z.ZodNativeEnum<
  typeof CatalogActivationState
> = z.nativeEnum(CatalogActivationState);
/** @internal */
export const CatalogActivationState$outboundSchema: z.ZodNativeEnum<
  typeof CatalogActivationState
> = CatalogActivationState$inboundSchema;
